import { StepState, StepAction, StepActionType } from '../types/stepsTypes';

export const initialState: StepState = {
  currentStep: -1,
  alreadyApplied: false,
};

const stepReducer = (state: StepState, action: StepAction): StepState => {
  switch (action.type) {
    case StepActionType.PREV_STEP:
      return {
        ...initialState,
        currentStep: state.currentStep - 1,
      };

    case StepActionType.NEXT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1,
      };

    case StepActionType.SET_STEP:
      return {
        ...state,
        currentStep: action.payload.currentStep,
        alreadyApplied: action.payload.alreadyApplied,
      };

    default:
      return state;
  }
};

export default stepReducer;
